import React from 'react';
import createReactClass from 'create-react-class';
import EasyPieChartLib from 'easy-pie-chart';

var EasyPieChart = createReactClass({
  getDefaultProps(){
    return {
      title: 'EasyPieChart',
      percent: 0,
      isIncreasing: true,
      color: '#a57225'
    };
  },

  getInitialState(){
    return {
      currentPercent : 0
    };
  },

  componentDidMount() {
    let pieSize = 50;

    var chartOptions = {
      barColor: this.props.color,
      trackColor: 'rgba(0,0,0,0.04)',
      scaleColor: !1,
      lineCap: 'butt',
      lineWidth: parseInt(pieSize / 8.5, 10),
      animate: 1500,
      rotate: -90,
      size: pieSize,
      onStep:(a, b, c) => {
        if (this.isMounted()) {
          this.setState({
            currentPercent: Math.round(c)
          });
        }
      }
    };

    new EasyPieChartLib(this.chart, chartOptions);
  },

  render() {


    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center'}}>
        <div ref={c => this.chart = c} className="easy-pie-chart" data-percent={this.props.percent}>
            <span className="percent percent-sign">{this.state.currentPercent}</span>
        </div>
      </div>
    );
  }
});

export default EasyPieChart;



// WEBPACK FOOTER //
// ./src/components/common/Diagrams/EasyPieChart.js